import * as TestPanel from '../testPanel'
import { AxiosHeaders, RequestClient, TypeGuards } from '@codeleap/common'
import { requestMiddleware } from './middlewares'

const baseURL = TestPanel.getServerUrl()

export const api = new RequestClient({
  baseURL,
  automaticMultipartParsing: true,
  headers: new AxiosHeaders(),
  multipartParser: (body) => {
    const form = new FormData()

    for (const [key, value] of Object.entries(body)) {
      if (value instanceof File) {
        form.append(key, value)
      } else if (TypeGuards.isArray(value) && value.every((v) => v instanceof File)) {
        value.forEach((v) => form.append(key, v))
      } else {
        if (TypeGuards.isNil(value)) continue

        form.append(key, JSON.stringify(value))
      }
    }
    return form
  },
  requestMiddleware,
})
